module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow-d16450c975be78838e1204887c413a78.png";